import React from "react";
import { Link } from "react-router-dom";
import { useLanguage } from "../../utils/translations";

const About = () => {
  const currentLang = useLanguage();
  const isEn = currentLang === 'en';
  const prefix = isEn ? '' : '/fr';

  const toolLinks = [
    { name: isEn ? 'PDF to Word' : 'PDF en Word', href: `${prefix}/PdfToWord` },
    { name: isEn ? 'PDF to Excel' : 'PDF en Excel', href: `${prefix}/PdfToExcel` },
    { name: isEn ? 'PDF to JPG' : 'PDF en JPG', href: `${prefix}/PdfToPng` },
    { name: isEn ? 'Merge PDFs' : 'Fusionner PDF', href: `${prefix}/MergePDFs` },
    { name: isEn ? 'Split PDF' : 'Diviser PDF', href: `${prefix}/SplitPDF` },
    { name: isEn ? 'PDF to PNG' : 'PDF en PNG', href: `${prefix}/PdfToPng` },
    { name: isEn ? 'Image to PDF' : 'Image en PDF', href: `${prefix}/ImageToPdf` },
    { name: isEn ? 'PDF Editor' : 'Éditeur PDF', href: `${prefix}/PDFEditor` },
  ];

  const utilityLinks = [
    { name: isEn ? 'Compare Text' : 'Comparer Texte', href: `${prefix}/CompareText` },
    { name: isEn ? 'JSON Editor' : 'Éditeur JSON', href: `${prefix}/JsonEditorApp` },
    { name: isEn ? 'PDF to CSV' : 'PDF en CSV', href: `${prefix}/PdfToCsv` },
    { name: isEn ? 'PDF to JSON' : 'PDF en JSON', href: `${prefix}/PdfToJson` },
    { name: isEn ? 'PDF to PPT' : 'PDF en PPT', href: `${prefix}/PdfToPpt` },
    { name: isEn ? 'Edit PDF Metadata' : 'Métadonnées PDF', href: `${prefix}/EditPDFMetadata` },
  ];

  return (
    <footer className="bg-[#323232] text-gray-300 mt-8" role="contentinfo">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
          {/* Brand */}
          <div>
            <h3 className="text-white text-lg font-semibold mb-3">PDFLove</h3>
            <p className="text-sm text-gray-300 leading-relaxed">
              {isEn
                ? 'Free online PDF tools to convert, edit, merge, split and manage your PDF files. No registration required.'
                : 'Outils PDF en ligne gratuits pour convertir, modifier, fusionner, diviser et gérer vos fichiers PDF. Aucune inscription requise.'}
            </p>
          </div>

          {/* Popular Tools */}
          <div>
            <h3 className="text-white text-sm font-semibold uppercase tracking-wider mb-3">
              {isEn ? 'Popular Tools' : 'Outils Populaires'}
            </h3>
            <ul className="space-y-1.5">
              {toolLinks.map((link) => (
                <li key={link.href}>
                  <Link to={link.href} className="text-sm text-gray-300 hover:text-white transition-colors">
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* More Tools */}
          <div>
            <h3 className="text-white text-sm font-semibold uppercase tracking-wider mb-3">
              {isEn ? 'More Tools' : 'Plus d\'Outils'}
            </h3>
            <ul className="space-y-1.5">
              {utilityLinks.map((link) => (
                <li key={link.href}>
                  <Link to={link.href} className="text-sm text-gray-300 hover:text-white transition-colors">
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="border-t border-gray-700 mt-8 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-gray-500">
            © {new Date().getFullYear()} PDFLove. {isEn ? 'All rights reserved.' : 'Tous droits réservés.'}
          </p>
          <div className="flex gap-4">
            <Link to={isEn ? '/' : '/fr'} className="text-xs text-gray-500 hover:text-white transition-colors">
              {isEn ? 'English' : 'Anglais'}
            </Link>
            <Link to={isEn ? '/fr' : '/'} className="text-xs text-gray-500 hover:text-white transition-colors">
              {isEn ? 'Français' : 'French'}
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default About;
